import React, {Component} from 'react';

export default class Loading extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: null
    }
  }

  visible(){
    return (this.props.isFetching)?'block':'none';
  }

  render() {
    return (
      <div id="loading" style={{display: this.visible()}}>
        <div className="inner">
          <div className="progress">
            <img src="/assets2/feature/peanuts/pc/images/loading@3x.gif"/>
          </div>
          <img className="title" src="/assets2/feature/peanuts/pc/images/txt_loading@3x.png"/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./source/javascripts/components/loading.js